export default __webpack_public_path__ + "static/incfMagazine-96b1739fcc30e2dbd94050e2afcac86f.mp4";